import React from 'react'
import { makeStyles } from '@material-ui/core'
import ProfilePicture from 'components/common/ProfilePicture'
import Tooltip from 'components/common/Tooltip'
import usePatientPresence from 'hooks/usePatientPresence'

const useStyles = makeStyles({
  pill: {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    height: 30,
    padding: '0 12px 0 4px',
    borderRadius: 18,
    background: '#fadec2',
    cursor: 'default'
  },
  avatar: {
    height: 22,
    width: 22,
    padding: 0,
    fontSize: 8
  },
  label: {
    maxWidth: 78,
    fontSize: 8,
    lineHeight: '11px',
    color: '#001337',
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden'
  }
})

// The patient-list marker only shows for patients that are in the list; this one covers the patient
// that is currently open, however it was reached (notifications, deep links, search). It sits in the
// name row so it wraps with the name and demographics instead of overlapping them.
const PatientHeaderPresenceMarker = ({ patientId }) => {
  const classes = useStyles()
  const presence = usePatientPresence(patientId)

  if (!presence) {
    return null
  }

  const { primary, tooltip } = presence

  return (
    <Tooltip value={tooltip} variant="dark" arrow placement="bottom">
      <div className={classes.pill} id="patient-header-presence-marker">
        <ProfilePicture photo={primary.photo} name={primary.name} size="custom" className={classes.avatar} />
        <span className={classes.label}>{tooltip}</span>
      </div>
    </Tooltip>
  )
}

export default PatientHeaderPresenceMarker
